import React from 'react';
import {
  PieChart as BasePieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from 'recharts';
import PropTypes from 'prop-types';

const PieChart = ({
  colors,
  data,
  startAngle = 0,
  endAngle = 360,
  noAnimation = false,
}) => (
  <ResponsiveContainer aspect={1} width="100%">
    <BasePieChart margin={{ top: 2, left: 2, right: 2, bottom: 2 }}>
      <Pie
        blendStroke
        data={data}
        dataKey="value"
        endAngle={endAngle}
        fill="#8884d8"
        innerRadius="60%"
        isAnimationActive={!noAnimation}
        outerRadius="100%"
        startAngle={startAngle}
      >
        {data.map((entry, index) => (
          <Cell fill={colors[index % (colors?.length || 0)]} key={entry.name} />
        ))}
      </Pie>
    </BasePieChart>
  </ResponsiveContainer>
);

PieChart.propTypes = {
  /** Array of color hex codes as strings, which are used for the chart sections */
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** Array containing the chart data */
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.number,
    }),
  ).isRequired,
  endAngle: PropTypes.number,
  noAnimation: PropTypes.bool,
  startAngle: PropTypes.number,
};

export default PieChart;
